// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"67567326","278":"53c25392","445":"df0361e0","745":"f97fc324"}[chunkId] + ".js";
};